import { gql } from '@apollo/client';
import { ReportSectionState } from '@mnd-frontend/graphql-schema';
import { GREY_900 } from '@mnd-frontend/ui/shared/tokens';
import type { Report2SummaryKeyMetricsFragment } from '../../../../../generated/types';
import { BrandReportMetrics, Section, SectionHeader, SkeletonMetrics } from '../../common';

export const REPORT2_SUMMARY_KEY_METRICS_FRAGMENT = gql`
  fragment Report2SummaryKeyMetrics on ReportSummaryKeyMetrics {
    id
    title
    state
    trialMentionsDisclaimer
    prValue
    prValuePreviousYear
    prValueCurrency
    estimatedReach
    estimatedReachPreviousYear
    mentions
    mentionsPreviousYear
    netSentimentScore
    shareOfVoice
    shareOfVoicePreviousYear
    visibleMetrics
    ...Report2Section
  }
`;

const SummaryKeyMetrics = ({ section }: { section: Report2SummaryKeyMetricsFragment }) => {
  const mentions = Number(section.mentions.toString());
  const mentionsPreviousYear = Number(section.mentionsPreviousYear.toString());
  const estimatedReach = Number(section.estimatedReach.toString());
  const estimatedReachPreviousYear = Number(section.estimatedReachPreviousYear.toString());
  const prValue = Number(section.prValue.toString());
  const prValuePreviousYear = Number(section.prValuePreviousYear.toString());
  const shareOfVoice = Number(section.shareOfVoice.toString());
  const shareOfVoicePreviousYear = Number(section.shareOfVoicePreviousYear.toString());
  const netSentimentScore = Number(section.netSentimentScore.toString());

  return (
    <Section>
      <SectionHeader
        color={GREY_900}
        as="h3"
        variant="reportHeadlineLarge"
        section={section}
        isSubsection
      />
      {section.state !== ReportSectionState.Done ? (
        <SkeletonMetrics />
      ) : (
        <BrandReportMetrics
          metrics={section.visibleMetrics}
          mentions={mentions}
          mentionsPreviousYear={mentionsPreviousYear}
          estimatedReach={estimatedReach}
          estimatedReachPreviousYear={estimatedReachPreviousYear}
          shareOfVoice={shareOfVoice}
          shareOfVoicePreviousYear={shareOfVoicePreviousYear}
          netSentimentScore={netSentimentScore}
          prValue={prValue}
          prValuePreviousYear={prValuePreviousYear}
          prValueCurrency={section.prValueCurrency}
          trialMentionsDisclaimer={section.trialMentionsDisclaimer}
        />
      )}
    </Section>
  );
};

export default SummaryKeyMetrics;
